import React from "react";
import { Link } from "react-router-dom";
import "./NotFound.scss";

const NotFound = () => (
  <section className="not-found" aria-labelledby="not-found-title">
    <p className="not-found__code">404</p>
    <h1 id="not-found-title" className="not-found__title">
      We couldn&apos;t find that&nbsp;page
    </h1>
    <p className="not-found__body">The link may be old or mistyped.</p>
    <Link to="/" className="not-found__home">
      Go to the home page
    </Link>
  </section>
);

export default NotFound;
